import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { } from 'googlemaps';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../hotel.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CancelInfoComponent } from '../cancel-info/cancel-info.component';
import { AmenityInfoComponent } from '../amenity-info/amenity-info.component';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { Options } from '@angular-slider/ngx-slider';
import { ConfirmationModelComponent } from './components/confirmation-model/confirmation-model.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-hotel-room-detail',
    templateUrl: './hotel-room-detail.component.html',
    styleUrls: ['./hotel-room-detail.component.scss']
})
export class HotelRoomDetailComponent implements OnInit {

    @ViewChild('mapContainer', { static: true }) gMap: ElementRef<HTMLDivElement>;
    @Input() hotel: any;
    @Input() traveller: any;
    public mealPlanSelected: boolean = false; 
    public filteredRoomDetails: any[] = []; 
    hotelRoomDetails: any[] = [];
    minValue: number = 0;
    maxValue: number = 0;
    minPrice: number;
    maxPrice: number;
    sliderOptions: Options = {
        floor: 0,
        ceil: 500
    };
    refundableSelected: boolean = false;
    map: any; //google.maps.Map;
    coordinates: any;
    lat: number;
    lng: number;
    marker: google.maps.Marker;
    details: any = {};
    mapLoaded: Promise<boolean>;
    protected subs = new SubSink();
    travellerAdult: any = 0;
    travellerChild: any = 0;
    showShortDescOverview = true;
    totalPrice: number = 0;
    allRoomsSelected: boolean = false;
    selectedRoomTypeName: string = ''; // Initialize with an empty string or default value
    selectedBoardType: string = '';
    selectedRoomId: string = '';
    visibleCancelPolicyIndex = -1;
    booking_source:any;
    activePanelId: string = 'ngb-panel-0';
    lastSelectedPanelIndex: number = 0;
    selectedRooms: any[] = [];
    selectedRoomIndex: number = null; // Track the selected room index
    selectedGroupIndex: number = null; // Track the selected group index
    roomTypes: string[];
  uniqueAmenities: unknown[];
    constructor(
        private hotelService: HotelService,
        private apiHandlerService: ApiHandlerService,
        private router: Router,
        private dialog: MatDialog,
        private utility: UtilityService,
        private cdr: ChangeDetectorRef,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
       // this.resizeMap();
       if (this.hotel && this.hotel.HotelAmenities) {
        this.uniqueAmenities = Array.from(new Set(this.hotel.HotelAmenities));
      }
        this.hotelRoomDetails = this.hotel['RoomDetails'] || [];
        this.booking_source=this.hotel.searchRequest.booking_source;
        console.log("booking_source",this.booking_source)
        console.log("hotelRoomDetails",this.hotelRoomDetails)
        this.scrollToRoomDetails();
        this.travellerAdult = this.traveller.adults;
        this.travellerChild = this.traveller.childrens;
        this.filteredRoomDetails = [...this.hotel.RoomDetails];
        this.initializeSliderRange();
        this.generateRoomTypeOptions();
    }

    resizeMap() {
        this.coordinates = { lat: this.hotel.Latitude, lng: this.hotel.Longitude };
       // this.mapInitializer();
    }

    mapInitializer() {
        this.map = new google.maps.Map(this.gMap.nativeElement, {
            center: new google.maps.LatLng(this.coordinates.lat, this.coordinates.lng),
            zoom: 17,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        console.log(this.map)
        this.placeMarker();
    }

    placeMarker() {
        let infowindow = new google.maps.InfoWindow()
        let latlngset = new google.maps.LatLng(this.coordinates.lat, this.coordinates.lng);
        let marker = new google.maps.Marker({
            map: this.map,
            title: this.hotel.HotelName,
            position: latlngset,
        });
        this.map.setCenter(marker.getPosition())
        let style_pop_up = 'height="60" width="60"';
        let style_image = 'height="30" width="30"';
        let pop_up_hotel_image = '<img src="' + this.hotel['HotelPicture'] + '" ' + style_pop_up + '>';
        let $pop_up = '<div style="width:300px; padding:2px;"><div class="mapplot" style="color:#3399FE;"> <div class="projimg1" style="float:left;"> ' + pop_up_hotel_image + '</div> <div class="mapplot_desc"><div style="color: royalblue; font-size: 14px; font-weight:bold;"> ' + this.hotel.HotelName + ', <small style="color:#000;"> ' + this.hotel.HotelAddress + '</small></div> <div style="float:left"> </div></div> </div></div></div>';
        let currentInfoWin = true;

        google.maps.event.addListener(marker, 'click', (function (marker, content, infowindow) {
            return function () {
                if (currentInfoWin) {
                    infowindow.close();
                }
                infowindow.setContent($pop_up);
                infowindow.open(this.map, marker);
                currentInfoWin = true;
            };
        })(marker, this.hotel.HotelName, infowindow));

    }

    scrollToRoomDetails() {
        this.hotelService.scrollToRoomDetails.subscribe(t => {
            if (t) {
                document.getElementById('roomDetail').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            }
        })
    }

    cancelInfo(data) {
        this.dialog.open(CancelInfoComponent, {
            data: data
        });
    }

    ameInfo(data1) {
        this.dialog.open(AmenityInfoComponent, {
            data: data1
        });
    }

    AmenityInfoComponent
    // selectedRoom(rooms, room,index) {
    //     console.log("room",room)
    //     this.totalPrice = 0;
    //     if (index == 0) {
    //         if (this.hotel && this.hotel?.RoomDetails) {
    //             for (let roomList of this.hotel?.RoomDetails) {
    //                 for (let roomDetail of roomList) {
    //                     roomDetail.SelectedRoom = null;
    //                 }
    //             }

    //         }
    //         if (this.hotel && this.hotel.RoomDetails) {
    //             for (let roomList of this.hotel.RoomDetails) {
    //                 for (let roomDetail of roomList) {
    //                     for(let room of roomDetail.Rooms){
    //                     room.SelectedIndex = null;
    //                     }
    //                 }
    //             }

    //         }
    //     }
    //     this.selectedRoomTypeName = room.Description;
    //     this.selectedBoardType = room.RoomType;
    //     this.selectedRoomId = room.Id;
    //     rooms.SelectedRoom = room;
    //     room.SelectedIndex = room.Index;
    //     if (this.hotel && this.hotel.RoomDetails) {
    //         for(let roomList of this.hotel.RoomDetails)
    //         roomList.forEach((roomDetail, index) => {
    //             console.log("roomDetail",roomDetail)
    //                 if(roomDetail.SelectedRoom){
    //                     this.totalPrice += roomDetail.SelectedRoom.Price[0].Amount;
    //                 }
    //                 console.log("this.totalPrice",this.totalPrice)
    //         });
            
    //     }

    //     if (this.hotel && this.hotel.RoomDetails) {
    //         this.allRoomsSelected = this.hotel.RoomDetails.every(roomList => {
    //             console.log("roomList",roomList)
    //             return roomList.some(room => room.SelectedRoom != null);
    //         });
    //     }
    //     const nextIndex = index + 1;
        
    //     if (nextIndex < this.hotel.RoomDetails.length) {
    //         // Move to the next panel if it exists
    //         this.activePanelId = `ngb-panel-${nextIndex}`;
    //         this.lastSelectedPanelIndex = nextIndex;
    //     } else {
    //         // If it is the last panel, stay on it
    //         this.activePanelId = `ngb-panel-${index}`;
    //         this.lastSelectedPanelIndex = index;
    //     }
       
    //     //this.allRoomsSelected = this.hotel.RoomDetails[0].every(room => room.SelectedRoom != null);
    // }

    selectedRoom(rooms, room, index, roomIndex, booking_source) {
        console.log("rooms", rooms);
        console.log("room", room);
        console.log("index", index);
        this.totalPrice = 0;
      
        const proceedWithSelection = () => {
          if (index === 0) {
            if (this.filteredRoomDetails && booking_source) {
              for (let roomList of this.filteredRoomDetails) {
                for (let roomDetail of roomList) {
                  roomDetail.SelectedRoom = null;
                  for (let r of roomDetail.Rooms) {
                    r.isSelected = false; // Reset the selection state
                  }
                }
                
              }
            }
            if (this.filteredRoomDetails && booking_source) {
              for (let roomList of this.filteredRoomDetails) {
                for (let roomDetail of roomList) {
                  for (let room of roomDetail.Rooms) {
                    for (let r of roomDetail.Rooms) {
                        r.isSelected = false; // Reset the selection state
                      }
                    room.SelectedIndex = null;
                  }
                }
              }
            }
          }
          this.selectedRoomTypeName = room.Description;
          this.selectedBoardType = room.RoomType;
          this.selectedRoomId = room.Id;
          rooms.SelectedRoom = room;
          room.SelectedIndex = room.Index;
          room.isSelected = true;
          if (this.filteredRoomDetails && booking_source) {
            for (let roomList of this.filteredRoomDetails)
              roomList.forEach((roomDetail) => {
                console.log("roomDetail", roomDetail);
                if (roomDetail.SelectedRoom) {
                  console.log("roomDetail.SelectedRoom", roomDetail.SelectedRoom);
                  this.totalPrice += roomDetail.SelectedRoom.Price[0].Amount;
                }
                console.log("this.totalPrice", this.totalPrice);
              });
          }
      
          if (this.filteredRoomDetails) {
            this.allRoomsSelected = this.filteredRoomDetails.every(roomList => {
              console.log("roomList DD", roomList);
              return roomList.some(room => room.SelectedRoom != null);
            });
          }
          this.selectedRoomIndex = index;
      
          const nextIndex = index + 1;
      
          if (nextIndex < this.filteredRoomDetails.length) {
            // Move to the next panel if it exists
            this.activePanelId = `ngb-panel-${nextIndex}`;
            this.lastSelectedPanelIndex = nextIndex;
          } else {
            // If it is the last panel, stay on it
            this.activePanelId = `ngb-panel-${index}`;
            this.lastSelectedPanelIndex = index;
          }
          this.selectedRoomIndex = roomIndex;
          this.selectedGroupIndex = index;
        };
        if (room.NonRefundable) {
          const modalRef = this.modalService.open(ConfirmationModelComponent);
          modalRef.result.then((result) => {
            if (result) {
              proceedWithSelection();
            }
          }, (reason) => {
            console.log('Dismissed');
          });
        } else {
          proceedWithSelection();
        }
      }
    

    trackByIndex(index: number): number {
        return index;
    }

    unselectRoom(groupIndex: number, roomId: string) {
        for (let roomList of this.filteredRoomDetails) {
          for (let roomDetail of roomList) {
            console.log("roomDetail",roomDetail)
            if (roomDetail.SelectedRoom && roomDetail.SelectedRoom.Id === roomId) {
              roomDetail.SelectedRoom = null;
              console.log(" roomDetail.SelectedRoom",roomDetail.SelectedRoom)
              for (let room of roomDetail.Rooms) {
                if (room.Id === roomId) {
                  room.isSelected = false;
                  room.SelectedIndex =null;
                   // Reset the selection state
                }
              }
            }
          }
        }
      
        this.updateTotalPriceAndSelectionState();
      }
    
    onPanelChange(panelIndex: string) {
        const index = parseInt(panelIndex.replace('ngb-panel-', ''), 10);
        this.activePanelId = panelIndex;
        this.lastSelectedPanelIndex = index;
    }
    onBookNow(hotel: any, rooms: any) {
        console.log("hotel ghjkmjnhg",hotel)
    	//this.booking_source = hotel.searchRequest.booking_source,
        this.hotelService.loading.next(true);
        let roomIndex=[];
        let resultToken=[];

        if (rooms) {
            console.log("hotel.RoomDetails",this.filteredRoomDetails)
            for (let roomDetails of this.filteredRoomDetails) {
                for (let rooms of roomDetails) {
                    if (rooms.SelectedRoom) {
                        resultToken.push(rooms.ResultIndex);
                    }
                }
            }
        }
        else {
            resultToken = [];
        }
        if (rooms) {
            console.log("hotel.RoomDetails",this.filteredRoomDetails)
            for (let roomDetails of this.filteredRoomDetails) {
                for (let rooms of roomDetails) {
                    for(let room of rooms.Rooms){
                        console.log("room hbjjjj",room)
                    if (room.SelectedIndex != null) {
                        roomIndex.push(room.Index)
                    }
                }
            }
            }
        }
        else {
            roomIndex = [];
        }
     
        const currentUserId = this.utility.readStorage('b2cUser', sessionStorage)['id'];
        this.subs.sink = this.apiHandlerService.apiHandler('blockRoom', 'POST', '', '', {
            ResultToken:resultToken,
            BlockRoomId:roomIndex,
            booking_source: hotel.searchRequest.booking_source,
        }).subscribe(res => {
            if (res.data) {
                this.hotelService.blockHotelRoom.next(res);
                localStorage.setItem('blockHotelRoomState', JSON.stringify(this.hotelService.blockHotelRoom.getValue()));
                this.hotelService.resultToken = res.ResultToken;
                this.hotelService.traveller = this.traveller;
                this.router.navigate(['/hotel-guests']);
            } else {
                this.hotelService.loading.next(false);
                alert(res.Message);
            }
            this.hotelService.loading.next(false);
        });
    }
    showSubCancelPolicy(cancelpolicy) {
        if (this.visibleCancelPolicyIndex === cancelpolicy) {
          this.visibleCancelPolicyIndex = -1;
        } else {
          this.visibleCancelPolicyIndex = cancelpolicy;
        }
      }
    amenityAvailable(item: string, match: string) {
        const regx = new RegExp(`${match}`, 'gi');
        if (item == match)
            return true;
        return false;
    }

    shortDescText() {
        this.showShortDescOverview = !this.showShortDescOverview
    }

      updateTotalPriceAndSelectionState() {
        this.totalPrice = 0;
        if (this.filteredRoomDetails) {
          for (let roomList of this.filteredRoomDetails) {
            for (let roomDetail of roomList) {
              if (roomDetail.SelectedRoom) {
                this.totalPrice += roomDetail.SelectedRoom.Price[0].Amount;

              }
            }
          }
        }
      
        if (this.filteredRoomDetails) {
          this.allRoomsSelected = this.filteredRoomDetails.every(roomList => {
            return roomList.some(roomDetail => roomDetail.SelectedRoom != null);
          });
        }
      }

    ngAfterViewInit() {
        setTimeout(() => {
            this.initializeSliderRange();
        });
    }

    initializeSliderRange(): void {
        console.log('Hotel Room Details:', this.hotelRoomDetails);
    
        if (Array.isArray(this.hotelRoomDetails)) {
            const prices = this.hotelRoomDetails
                .map(group => {
                    if (Array.isArray(group)) {
                        return group
                            .map(roomGroup => {
                                if (Array.isArray(roomGroup.Rooms)) {
                                    return roomGroup.Rooms
                                        .map(room => {
                                            if (Array.isArray(room.Price) && room.Price.length > 0) {
                                                return room.Price[0]?.Amount ?? 0; 
                                            }
                                            return 0; 
                                        });
                                }
                                return []; 
                            })
                            .reduce((acc, val) => acc.concat(val), []); 
                    }
                    return []; 
                })
                .reduce((acc, val) => acc.concat(val), []); 
    
            console.log('Prices:', prices);
    
            if (prices.length > 0) {
                this.minPrice = Math.min(...prices);
                this.maxPrice = Math.max(...prices);
    
                this.minValue = this.minPrice;
                this.maxValue = this.maxPrice;
    
                this.sliderOptions = {
                    floor: this.minPrice,
                    ceil: this.maxPrice
                };
    
                this.filterRoomOptions();
            } else {
                console.warn('No valid prices available to set slider range.');
            }
        } else {
            console.warn('Hotel Room Details is not an array or is undefined.');
        }
    }
    
    

    applyMealPlanFilter(room: any): boolean {
        return !this.mealPlanSelected || room.RoomType === this.mealPlanSelected;
    }
    
    filterRoomOptions(): void {
        this.filteredRoomDetails = this.hotelRoomDetails.map((roomGroup, groupIndex) =>
            roomGroup.map((roomDetails, roomIndex) => ({
                ...roomDetails,
                originalGroupIndex: groupIndex, 
                originalRoomIndex: roomIndex,   
                Rooms: roomDetails.Rooms.filter(room =>
                    this.applyMealPlanFilter(room) &&
                    this.applyPriceFilter(room) &&
                    this.applyRefundableFilter(room) 
                )
            }))
        );
    }
    

    generateRoomTypeOptions(): void {
        const roomTypesSet = new Set<string>();
        this.hotelRoomDetails.forEach(roomGroup => {
            roomGroup.forEach(roomDetails => {
                roomDetails.Rooms.forEach(room => {
                    if (room.RoomType) {
                        roomTypesSet.add(room.RoomType);
                    }
                });
            });
        });
        this.roomTypes = Array.from(roomTypesSet);
    }
    
    
    applyRefundableFilter(room: any): boolean {
        return !this.refundableSelected || !room.NonRefundable;
    }
    
    onRefundableChange(event: any): void {
        this.refundableSelected = event.target.checked;
        this.filterRoomOptions();
    }

    applyPriceFilter(room: any): boolean {
        return room.Price[0].Amount >= this.minValue && room.Price[0].Amount <= this.maxValue;
    }

    onMealPlanChange(event: any): void {
        this.mealPlanSelected = event.target.value; 
        this.filterRoomOptions();
    }
    

    valueChange(minVal: number): void {
        this.minValue = minVal;
        this.filterRoomOptions();
    }

    highValueChange(maxVal: number): void {
        this.maxValue = maxVal;
        this.filterRoomOptions();
    }
}


